// extracted by mini-css-extract-plugin
module.exports = {"globals":"\"../GlobalStyles.css\"","uiGrayDarker":"#151A1F","uiBorderColor":"#44626F","textActiveColor":"#7cf4fe","textSecondaryColor":"#b8baee"};